import type {FetchErrorResponse} from '@stripe-internal/connect-embedded-lib';
import {FetchApiError} from '@stripe-internal/connect-embedded-lib';

export const errorMessage = (error: any): string => {
  return error instanceof Error ? error.message : String(error);
};

export type SerializedFetchError = {
  errorMessage: string;
  errorResponse: FetchErrorResponse;
};

export const serializeFetchErrorForPostMessage = (
  error: FetchApiError,
): SerializedFetchError => {
  return {
    errorMessage: error.message,
    errorResponse: error.error,
  };
};

export const deserializeFetchErrorFromPostMessage = (
  error: SerializedFetchError,
): FetchApiError => {
  return new FetchApiError(error.errorMessage, error.errorResponse);
};
